/**<params config data>说明
 * titleFontSize 标题文字大小 number
 * titleColor 标题文字颜色 string
 * desFontSize 描述文字大小 number
 * desColor 描述文字颜色 string
 * background 颜色：string
 * layout 定位 string
 * data 数据 array
 */
import ScrollAnimation from '@/components/Animate';
import css from './index.module.scss';
const items = [
    {
        title: 'Let’s get down to details.',
        des: 'DELTA Pro is designed inside and out for ease of use, durability and safety. Take a closer look. ',
    },
];
const configs = {
    animateIn: 'fadeInUp',
    titleFontSize: 56,
    titleColor: '#03060b',
    desFontSize: 22,
    desColor: '#919191',
    layout: 'left',
    maxWidth: 'auto',
};
export default function SmallTextModule({ config, data = items }: any) {
    const configTypes = { ...configs, ...config };
    const arr: any = {
        xs: 30,
        sm: 60,
        md: 90,
        lg: 120,
        xl: 150,
        xxl: 180,
    };
    return (
        <div className={`${css.SmallTextModule} container`}>
            {data.map((item: any, i: any) => (
                <div key={item.title} className={configTypes.layout == 'left' ? 'content' : 'content twoside'}>
                    <ScrollAnimation animateIn={configTypes.animateIn} className="animation-wrap" style={{ maxWidth: configTypes.maxWidth }}>
                        <h2
                            className="title"
                            style={{
                                fontSize: configTypes.titleFontSize + 'px',
                                color: configTypes.titleColor,
                            }}
                        >
                            {item.title}
                        </h2>
                        <p
                            className="des"
                            style={{
                                fontSize: configTypes.desFontSize + 'px',
                                color: configTypes.desColor,
                            }}
                        >
                            {item.des}
                        </p>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    );
}
